import { Inject } from '@angular/core';
import '@angular/compiler';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PageMypageEditComponent } from './page.mypage.edit/page.mypage.edit.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageSettingsComponent } from './page.settings/page.settings.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageRecordsComponent } from './page.records/page.records.component';
import { PageAnalysisComponent } from './page.analysis/page.analysis.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { LayoutAppComponent } from './layout.app/layout.app.component';
import { PageConstitutionComponent } from './page.constitution/page.constitution.component';
import { PageChatbotComponent } from './page.chatbot/page.chatbot.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageOnboardingComponent } from './page.onboarding/page.onboarding.component';
import { ComponentNavBottomComponent } from './component.nav.bottom/component.nav.bottom.component';
import { PageRootComponent } from './page.root/page.root.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        LayoutAuthComponent,
        PageMypageEditComponent,
        PortalSeasonLoadingSeasonComponent,
        PageSettingsComponent,
        PageHomeComponent,
        PageMypageComponent,
        PageRecordsComponent,
        PageAnalysisComponent,
        PortalSeasonLoadingDefaultComponent,
        LayoutAppComponent,
        PageConstitutionComponent,
        PageChatbotComponent,
        PortalSeasonFormDropdownComponent,
        PageOnboardingComponent,
        ComponentNavBottomComponent,
        PageRootComponent,
        PortalSeasonTreeComponent,
        PageLoginComponent,
        PortalSeasonModalComponent,
        PortalSeasonPaginationComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }